import React from 'react';
import { Container, Skeleton, Status } from '@exxonmobil/react-unity';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT } from '../date';

interface Props {
  title: string;
  isLoading?: boolean;
}

const PageTitle = ({ title, isLoading }: Props) => {
  const currentTime = dayjs().format(DATE_TIME_FORMAT);
  return (
    <TitleContainer>
      <Container>
        {isLoading && <Skeleton height="3rem" width="30%" />}
        {title && <h2>{title}</h2>}
        <Status>
          Last updated &nbsp;
          {currentTime}
        </Status>
      </Container>
    </TitleContainer>
  );
};

const TitleContainer = styled.div`
  padding: 2.5rem 0 3rem;
  border-bottom: 1px solid #e5e5e5;
  background-color: white;
  margin-bottom: 2rem;
`;

export default PageTitle;
